import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt'
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch'
import { faSuitcase } from '@fortawesome/free-solid-svg-icons/faSuitcase'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle'
import { faMapMarkerAlt as faMapMarkerAltLight } from '@fortawesome/pro-light-svg-icons/faMapMarkerAlt'
import { faSearch as faSearchLight } from '@fortawesome/pro-light-svg-icons/faSearch'
import { faTimesCircle as faTimesCircleLight } from '@fortawesome/pro-light-svg-icons/faTimesCircle'
import { useRef } from 'react'

import { NAV_BRAND } from '@/config'
import { PORTAL_TYPE_YF, PORTAL_TYPE_RJA } from '@/config/constants'

const portalIconsMapping = {
  searchTerm: {
    [PORTAL_TYPE_YF]: faSuitcase,
    [PORTAL_TYPE_RJA]: faSearchLight
  },
  searchLocation: {
    [PORTAL_TYPE_RJA]: faMapMarkerAltLight
  },
  searchBtn: {
    [PORTAL_TYPE_RJA]: faSearchLight
  },
  clearBtn: {
    [PORTAL_TYPE_RJA]: faTimesCircleLight
  }
}

const useSearchIcons = () => {
  const { portal_type: portalType } = NAV_BRAND
  const { current: searchTermIcon } = useRef(portalIconsMapping.searchTerm[portalType] || faSearch)
  const { current: searchLocationIcon } = useRef(portalIconsMapping.searchLocation[portalType] || faMapMarkerAlt)
  const { current: searchBtnIcon } = useRef(portalIconsMapping.searchBtn[portalType] || faSearch)
  const { current: clearIcon } = useRef(portalIconsMapping.clearBtn[portalType] || faTimesCircle)
  return { searchTermIcon, searchLocationIcon, searchBtnIcon, clearIcon }
}

export default useSearchIcons
